export default {
  getterListOrder: state => state.listOrder,
}
